import { apiClient, Auth } from '@/shared/api'

import { TGuestContractDetail } from '../model/schema'

export type GuestContractEstimateParams = {
  rid: number
  startDate: string
  endDate: string
  isExtend: boolean
  initialContractId?: number
}

export type ContractEstimate = Pick<
  TGuestContractDetail,
  | 'roomName'
  | 'picMain'
  | 'addrLot'
  | 'addrStreet'
  | 'hostName'
  | 'hostPhoneNumber'
  | 'guestName'
  | 'guestPhoneNumber'
  | 'week'
  | 'startDate'
  | 'endDate'
  | 'refundTerms'
  | 'usingFee'
  | 'longTermDiscount'
  | 'earlyDiscount'
  | 'mgmtFee'
  | 'cleanFee'
  | 'contractFee'
  | 'realUsingFee'
  | 'deposit'
  | 'finalPayFee'
>

export const getGuestContractEstimate = async (
  request: GuestContractEstimateParams,
) => {
  const { data } = await apiClient.get<ContractEstimate>({
    endpoint: `/guest/contracts/estimate`,
    auth: Auth.REQUIRED,
    queryParams: request,
  })

  return data
}
